<template>
  <transition ref="pferd"
              name="collapse"
              @enter="enter"
              @leave="leave"
              @enter-cancelled="enterCancelled"
              @leave-cancelled="leaveCancelled"
              @after-leave="complete"
              @after-enter="complete">
    <slot />
  </transition>
</template>


<script>
import { TweenMax, TimelineMax, Power3 } from 'gsap';

export default {
  name: 'TransitionCollapse',
  css: false,

  methods: {
    enter: function (el, done) {
      TweenMax.set(el, { height: 'auto' });
      TweenMax.from(el, 0.4, { height: 0, ease: Power3.easeInOut, onComplete: done });
    },
    enterCancelled: function (el) {
    },
    leave: function (el, done) {
      TweenMax.to(el, 0.4, { height: 0, ease: Power3.easeInOut, onComplete: done });
    },
    leaveCancelled: function (el) {
    },
    complete: function () {
      this.$emit('complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/transitions/TransitionCollapse.vue